import styled from 'styled-components'

export const DropDownContainer = styled.div`
  .selection__container {
    display: flex;
  }

  .selection__dropdown-container {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    height: 48px;
    border: 1px solid rgba(0, 0, 0, 0.301961);
  }

  .selection__dropdown-item-container {
    position: absolute;
    width: 100%;
    display: none;
  }

  .Menu-item {
    background-color: ${({ theme }) => theme.webMktNewPalette.white};
    padding-top: 12px;
    padding-bottom: 12px;

    p {
      margin: 0;
      line-height: 24px;
    }
  }

  .Menu-item.is-active:before {
    border-color: ${({ theme }) => theme.webMktPalette.background.black};
  }

  .selected__menu-item {
    color: ${({ theme }) => theme.webMktPalette.text.tertiaryLight};
    text-transform: capitalize;
  }

  .filter__button {
    margin-left: 16px;
    min-width: 48px;
    width: 48px;
    height: 48px;
  }

  .filter__icon {
    width: 100%;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    display: none;
  }

  .is-active {
    display: block;
    ${({ theme }) => theme.breakpoints.down('sm')} {
      z-index: 4;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex: 1;
  }

  .selection__dropdown-item-container > .CTA {
    display: flex;
    border-left: 1px solid ${({ theme }) => theme.webMktPalette.text.tertiaryLight};
    border-right: 1px solid ${({ theme }) => theme.webMktPalette.text.tertiaryLight};
    border-top: 1px solid ${({ theme }) => theme.webMktPalette.text.tertiaryLight};
  }

  .button__selected {
    background-color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
    color: ${({ theme }) => theme.webMktPalette.text.primaryWhite};
  }
`
